export const STUDENT_POLL_TIME = 25;
export const INSTRUCTOR_POLL_TIME = 25;
